import { BodyText, Flex, Heading } from "@utilitywarehouse/hearth-react";

const PreviouslySubmitted: React.FC = () => {
  return (
    <Flex direction="column" marginTop="150" gap="250">
      <Heading size="xl">
        You've already submitted your vulnerability assessment
      </Heading>
      <Flex direction="column" gap="350">
        <BodyText>
          If you'd like to make any changes, you'll need to restart from the
          beginning.
        </BodyText>
        <BodyText>
          <b>To restart this form</b>, please use the link originally provided
          in the <b>text message</b> or <b>email</b> you received from our
          customer support team.
        </BodyText>
        <BodyText>
          If you are still having issues then please contact our customer
          support team on <b>0333 777 0777</b>.
        </BodyText>
      </Flex>
    </Flex>
  );
};

export default PreviouslySubmitted;
